module.exports = __webpack_public_path__ + "static/media/editor-dark.a634097a.svg";